export default __webpack_public_path__ + "static/media/nous_connaitre_4.9a7d0e50.svg";